var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4Metering(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 29h-3V19h3v10zm9.9-7.48l-2.9-.9-2.83 9 2.86.9 2.87-9zm5.52 3.71l-4.08 6.84 2.58 1.54L58 26.77l-2.58-1.54zm-35 .49l4.4 7.83 2.62-1.47-4.4-7.83-2.62 1.47zM68 38a29 29 0 11-57.999 0A29 29 0 0168 38zm-4 0a25 25 0 10-50.001 0A25 25 0 0064 38zm-25.86 7l-7.51-25.14-2.87.86L35 45h3.14zM28 56h22v-7H28v7z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A4_Metering.0d08433c.svg";
export { SvgA4Metering as ReactComponent };